import { ELkType } from '../../repositories/lk-type/entities/get_lk_type_v2/GetLkTypeResponseV2';
import { TUser } from '../../types/currentUser';

export function reviewAllowedMapper(user: TUser, lkType: ELkType | null) {
  return Boolean(user) && lkType !== ELkType.Specialist;
}
